import { Filters } from 'src/pages/FuelTrackingHistory/types'

export const DEFAULT_FILTERS: Filters = {
  minOdometer: null,
  maxOdometer: null,
  minFuelQuantity: null,
  maxFuelQuantity: null,
  fuelType: null,
  minFuelPricePerLiter: null,
  maxFuelPricePerLiter: null,
  minTotalCost: null,
  maxTotalCost: null,
}
